import { render, staticRenderFns } from "./CommonPlusIcon.vue?vue&type=template&id=24a30977"
import script from "./CommonPlusIcon.vue?vue&type=script&lang=js"
export * from "./CommonPlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports